import { KeyValueModel } from "model/api";
import { EnumIndstatusStatus } from "model/enums/enum-indstatus-status";

export const StatusIndstatusMock: KeyValueModel[] = [
    new KeyValueModel(EnumIndstatusStatus.ATIVADO, "Ativado"),
    new KeyValueModel(EnumIndstatusStatus.DESATIVADO, "Desativado"),
];

export const StatusIndstatusMockTodos: KeyValueModel[] = [
    new KeyValueModel(EnumIndstatusStatus.ATIVADO, "Ativado"),
    new KeyValueModel(EnumIndstatusStatus.DESATIVADO, "Desativado"),
    new KeyValueModel(-1, "Todos"),
];